// src/components/CareerHome.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';

const CareerHome = () => {
  const [lang, setLang] = useState("en");

useEffect(() => {
  const saved = localStorage.getItem("lang");
  if (saved) setLang(saved);
}, []);

const changeLang = (l) => {
  setLang(l);
  localStorage.setItem("lang", l);
};

const t = {
  en: {
    title: "Careers @ CertNexuse",
    subtitle: "Join our team and grow with a company that values certification excellence, innovation, and work-life balance.",
    findJob: "Find a Job",
    openings: "Current Openings:",
    tele: "Tele-calling roles for girls (Safe environment + Good incentives) – Active Vacancy!",
    it: "IT Positions – Currently no openings (Check back soon)",
    nonit: "Non-IT / Support roles – Coming soon",
    search: "Search Open Jobs →",
    life: "Life at CertNexuse",
    lifeDesc: "CertNexuse is a Nagpur-based ISO certified company with developers, certification experts, sales & support team. We promote a positive work culture and work-life balance.",
    discover: "Discover Life Here →",
    hire: "How we hire",
    process: "Simple & Transparent Process:",
    step1: "Application Submit (Form or Email)",
    step2: "Resume Screening (1-3 days)",
    step3: "Telephonic / Online Interview",
    step4: "Final Discussion & Offer",
    total: "Total Time: 7-15 days",
    learn: "Learn Hiring Process →",
    ready: "Ready to Join CertNexuse?",
    send: "Send your resume to careers@certnexuse.com or apply below.",
    apply: "Apply Now",
    formTitle: "Job Application Form",
    submit: "Submit Application",
    submitting: "Submitting...",
    success: "Application Submitted Successfully! We will contact you soon.",
    error: "Something went wrong. Please try again."
  },

  mr: {
    title: "करिअर @ CertNexuse",
    subtitle: "आमच्या टीममध्ये सामील व्हा आणि उत्कृष्टता, नवकल्पना आणि work-life balance असलेल्या कंपनीसोबत वाढ करा.",
    findJob: "नोकरी शोधा",
    openings: "सध्याच्या रिक्त जागा:",
    tele: "मुलींसाठी टेलीकॉलिंग जॉब (सुरक्षित वातावरण + चांगले incentives) – उपलब्ध!",
    it: "IT पदे – सध्या रिक्त नाहीत",
    nonit: "Non-IT / सपोर्ट – लवकरच येत आहेत",
    search: "नोकऱ्या शोधा →",
    life: "CertNexuse मधील जीवन",
    lifeDesc: "CertNexuse ही नागपूरमधील ISO प्रमाणित कंपनी आहे. आमच्याकडे developers, experts, sales आणि support टीम आहे.",
    discover: "येथील जीवन जाणून घ्या →",
    hire: "भरती प्रक्रिया",
    process: "सोपे आणि पारदर्शक प्रक्रिया:",
    step1: "अर्ज सबमिट",
    step2: "Resume तपासणी",
    step3: "इंटरव्ह्यू",
    step4: "Final ऑफर",
    total: "एकूण वेळ: 7-15 दिवस",
    learn: "प्रक्रिया जाणून घ्या →",
    ready: "CertNexuse मध्ये सामील होण्यासाठी तयार आहात?",
    send: "तुमचा resume careers@certnexuse.com वर पाठवा",
    apply: "आता अर्ज करा",
    formTitle: "नोकरी अर्ज फॉर्म",
    submit: "अर्ज सबमिट करा",
    submitting: "सबमिट होत आहे...",
    success: "अर्ज यशस्वीरित्या सबमिट झाला!",
    error: "काहीतरी चूक झाली."
  },

  hi: {
    title: "करियर @ CertNexuse",
    subtitle: "हमारी टीम में शामिल हों और एक ऐसी कंपनी के साथ आगे बढ़ें जो उत्कृष्टता और संतुलन को महत्व देती है।",
    findJob: "नौकरी खोजें",
    openings: "वर्तमान रिक्तियां:",
    tele: "लड़कियों के लिए टेली-कॉलिंग जॉब – उपलब्ध!",
    it: "आईटी पद – अभी उपलब्ध नहीं",
    nonit: "नॉन-आईटी – जल्द आ रहा है",
    search: "नौकरियां खोजें →",
    life: "CertNexuse में जीवन",
    lifeDesc: "CertNexuse नागपुर की ISO प्रमाणित कंपनी है जिसमें डेवलपर्स और सपोर्ट टीम है।",
    discover: "यहां का जीवन देखें →",
    hire: "हम कैसे भर्ती करते हैं",
    process: "सरल प्रक्रिया:",
    step1: "आवेदन करें",
    step2: "रिज्यूमे जांच",
    step3: "इंटरव्यू",
    step4: "ऑफर",
    total: "समय: 7-15 दिन",
    learn: "प्रक्रिया जानें →",
    ready: "क्या आप जुड़ने के लिए तैयार हैं?",
    send: "अपना रिज्यूमे careers@certnexuse.com पर भेजें",
    apply: "अभी आवेदन करें",
    formTitle: "जॉब आवेदन फॉर्म",
    submit: "आवेदन जमा करें",
    submitting: "सबमिट हो रहा है...",
    success: "आवेदन सफलतापूर्वक जमा हुआ!",
    error: "कुछ गलत हो गया।"
  }
};
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    dob: '',
    gender: 'Male',
    tenthPercentage: '',
    twelfthPercentage: '',
    highestQualification: 'Graduate',
    currentLocation: '',
    applyingFor: 'IT Position',
    message: ''
  });
  const [status, setStatus] = useState(''); // '' | 'loading' | 'success' | 'error'

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('loading');

    const serviceID = 'service_7o2vscq';
    const templateID = 'template_tw2co8q';
    const publicKey = 'ASvyy0reI1mYzw6hn';

    emailjs.send(serviceID, templateID, formData, publicKey)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setStatus('success');
        setTimeout(() => {
          setModalOpen(false);
          setFormData({
            fullName: '', email: '', phone: '', dob: '', gender: 'Male',
            tenthPercentage: '', twelfthPercentage: '', highestQualification: 'Graduate',
            currentLocation: '', applyingFor: 'IT Position', message: ''
          });
          setStatus('');
        }, 3000);
      })
      .catch((err) => {
        console.error('FAILED...', err);
        setStatus('error');
      });
  };

  return (
    
    <div style={{ 
      padding: '4rem 2rem 6rem', 
      maxWidth: '1400px', 
      margin: '0 auto',
      background: 'linear-gradient(to bottom, #f8f9ff, #ffffff)',
    }}>
      
      {/* LANGUAGE SWITCHER */}
      {/* <div className="lang-switcher">
        <button onClick={() => setLang("en")} className={lang === "en" ? "active" : ""}>English</button>
        <button onClick={() => setLang("hi")} className={lang === "hi" ? "active" : ""}>हिंदी</button>
        <button onClick={() => setLang("mr")} className={lang === "mr" ? "active" : ""}>मराठी</button>
      </div> */}
      {/* Hero / Main Title */}
      <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
        <h1 style={{ 
          fontSize: '3.5rem', 
          color: '#0A1D56', 
          fontWeight: 'bold',
          marginBottom: '1rem' 
        }}>
          {t[lang].title}
        </h1>
        <p style={{ 
          fontSize: '1.5rem', 
          color: '#4a5568', 
          maxWidth: '800px', 
          margin: '0 auto' 
        }}>
          {t[lang].subtitle}
        </p>
      </div>

      {/* तीन मुख्य सेक्शन - Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
        gap: '2.5rem',
      }}>
        {/* Find a Job - updated vacancy info + active button */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
          padding: '2.5rem',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-10px)'; e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,123,255,0.15)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)'; }}
        >
          <h2 style={{ color: '#007bff', fontSize: '2.2rem', marginBottom: '1.5rem' }}>
            {t[lang].findJob}
          </h2>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ marginBottom: '1rem', fontSize: '1.1rem' }}><strong>{t[lang].openings}</strong></li>
            <li style={{ marginBottom: '1rem', fontSize: '1.1rem', color: '#e74c3c', fontWeight: 'bold' }}>
              {t[lang].tele}
            </li>
            <li style={{ marginBottom: '1rem', fontSize: '1.1rem', color: '#999' }}>
              {t[lang].it}
            </li>
            <li style={{ marginBottom: '1rem', fontSize: '1.1rem', color: '#999' }}>
              {t[lang].nonit}
            </li>
          </ul>
          <Link to="/career/jobs">
            <button style={{
              background: '#007bff',
              color: 'white',
              border: 'none',
              padding: '1rem 2.2rem',
              borderRadius: '50px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer',
              marginTop: '1rem'
            }}>
              {t[lang].search}
            </button>
          </Link>
        </div>

        {/* Life at CertNexuse - added description + images */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
          padding: '2.5rem',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-10px)'; e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,123,255,0.15)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)'; }}
        >
          <h2 style={{ color: '#007bff', fontSize: '2.2rem', marginBottom: '1.5rem' }}>
            {t[lang].life}
          </h2>
          <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', color: '#4a5568' }}>
            {t[lang].lifeDesc}
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
            <img 
              src="https://static.toiimg.com/thumb/msid-127547609,width-1280,height-720,imgsize-98518,resizemode-6,overlay-toi_sw,pt-32,y_pad-600,x_pad-1200/photo.jpg" 
              alt="Happy Indian office team" 
              style={{ width: '100%', borderRadius: '8px' }} 
            />
            <img 
              src="https://www.stayvista.com/blog/wp-content/uploads/2025/09/pngtree-employee-celebrating-diwali-together-in-office-photo-image_16112385.jpg" 
              alt="Team celebrating together" 
              style={{ width: '100%', borderRadius: '8px' }} 
            />
            <img 
              src="https://officebanao.com/wp-content/uploads/2024/04/Office-work-culture.webp" 
              alt="Positive office work culture" 
              style={{ width: '100%', borderRadius: '8px' }} 
            />
            <img 
              src="https://media.gettyimages.com/id/2190818894/video/professionals-working-in-the-office-environment-wearing-headsets-and-using-laptops-in-a.jpg?s=640x640&k=20&c=UDMJR09tZBNc2BHqp9oAxSAC7T3qkHt9U--iZ6tbTf4=" 
              alt="Call center team working" 
              style={{ width: '100%', borderRadius: '8px' }} 
            />
          </div>
          <Link to="/career/life">
            <button style={{
              background: '#007bff',
              color: 'white',
              border: 'none',
              padding: '1rem 2.2rem',
              borderRadius: '50px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer',
              marginTop: '1rem'
            }}>
              {t[lang].discover}
            </button>
          </Link>
        </div>

        {/* How we hire - added simple process steps */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
          padding: '2.5rem',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-10px)'; e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,123,255,0.15)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)'; }}
        >
          <h2 style={{ color: '#007bff', fontSize: '2.2rem', marginBottom: '1.5rem' }}>
            {t[lang].hire}
          </h2>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ marginBottom: '1rem', fontSize: '1.1rem' }}><strong>{t[lang].process}</strong></li>
            <li style={{ marginBottom: '0.8rem' }}>1. {t[lang].step1}</li>
            <li style={{ marginBottom: '0.8rem' }}>1. {t[lang].step2}</li>
            <li style={{ marginBottom: '0.8rem' }}>1. {t[lang].step3}</li>
            <li style={{ marginBottom: '0.8rem' }}>1. {t[lang].step4}</li>
            <li style={{ marginBottom: '1.5rem', color: '#28a745', fontWeight: 'bold' }}>
              {t[lang].total}
            </li>
          </ul>
          <Link to="/career/hiring">
            <button style={{
              background: '#007bff',
              color: 'white',
              border: 'none',
              padding: '1rem 2.2rem',
              borderRadius: '50px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer',
              marginTop: '1rem'
            }}>
              {t[lang].learn}
            </button>
          </Link>
        </div>
      </div>

      {/* Bottom CTA - Apply Now Button */}
      <div style={{ textAlign: 'center', marginTop: '5rem' }}>
        <h3 style={{ fontSize: '2rem', color: '#0A1D56' }}>
          {t[lang].ready}
        </h3>
        <p style={{ fontSize: '1.2rem', color: '#4a5568', margin: '1rem 0 2rem' }}>
          {t[lang].send}
        </p>
        <button 
          onClick={() => setModalOpen(true)}
          style={{
            background: '#28a745',
            color: 'white',
            border: 'none',
            padding: '1.2rem 3rem',
            borderRadius: '50px',
            fontSize: '1.3rem',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          {t[lang].apply}
        </button>
      </div>

      {/* Apply Form Modal - unchanged */}
      {modalOpen && (
        <div style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '2rem',
            width: '90%',
            maxWidth: '600px',
            maxHeight: '90vh',
            overflowY: 'auto',
            position: 'relative',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
          }}>
            <button
              onClick={() => setModalOpen(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '15px',
                fontSize: '2rem',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#333'
              }}
            >
              ×
            </button>

            <h2 style={{ textAlign: 'center', color: '#0A1D56', marginBottom: '1.5rem' }}>
              {t[lang].formTitle}
            </h2>

            <form onSubmit={handleSubmit}>
              <input type="text" name="fullName" placeholder="Full Name *" required value={formData.fullName} onChange={handleChange} style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '6px', border: '1px solid #ccc' }} />

              <input type="email" name="email" placeholder="Email *" required value={formData.email} onChange={handleChange} style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '6px', border: '1px solid #ccc' }} />

              <input type="tel" name="phone" placeholder="Phone Number *" required value={formData.phone} onChange={handleChange} style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '6px', border: '1px solid #ccc' }} />

              <input type="date" name="dob" placeholder="Date of Birth *" required value={formData.dob} onChange={handleChange} style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '6px', border: '1px solid #ccc' }} />

              <select name="gender" value={formData.gender} onChange={handleChange} style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '6px', border: '1px solid #ccc' }}>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>

              <input type="text" name="tenthPercentage" placeholder="10th Percentage / Grade" value={formData.tenthPercentage} onChange={handleChange} style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '6px', border: '1px solid #ccc' }} />

              <input type="text" name="twelfthPercentage" placeholder="12th Percentage / Grade" value={formData.twelfthPercentage} onChange={handleChange} style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '6px', border: '1px solid #ccc' }} />

              <select name="highestQualification" value={formData.highestQualification} onChange={handleChange} style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '6px', border: '1px solid #ccc' }}>
                <option value="10th">10th</option>
                <option value="12th">12th</option>
                <option value="Diploma">Diploma</option>
                <option value="Graduate">Graduate</option>
                <option value="Post Graduate">Post Graduate</option>
                <option value="Other">Other</option>
              </select>

              <input type="text" name="currentLocation" placeholder="Current Location (City)" value={formData.currentLocation} onChange={handleChange} style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '6px', border: '1px solid #ccc' }} />

              <select name="applyingFor" value={formData.applyingFor} onChange={handleChange} style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '6px', border: '1px solid #ccc' }}>
                <option value="IT Position">IT Position</option>
                <option value="Non-IT Position">Non-IT Position</option>
                <option value="Tele-calling for Girls">Tele-calling for Girls</option>
                <option value="Other">Other</option>
              </select>

              <p style={{ color: '#666', fontSize: '0.9rem', margin: '10px 0' }}>
                Resume Upload: कृपया careers@certnexuse.com वर resume पाठवा किंवा Google Drive link खाली द्या.
              </p>

              <textarea name="message" placeholder="Why do you want to join CertNexuse? (Optional)" value={formData.message} onChange={handleChange} rows={4} style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '6px', border: '1px solid #ccc' }} />

              <button 
                type="submit" 
                disabled={status === 'loading'}
                style={{
                  width: '100%',
                  padding: '12px',
                  marginTop: '1rem',
                  backgroundColor: status === 'loading' ? '#ccc' : '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1.1rem',
                  cursor: status === 'loading' ? 'not-allowed' : 'pointer'
                }}
              >
                {status === "loading" ? t[lang].submitting : t[lang].submit}
              </button>
            </form>

            {status === 'success' && (
              <p style={{ color: 'green', textAlign: 'center', marginTop: '1rem', fontWeight: 'bold' }}>
                {status === "success" && <p>{t[lang].success}</p>}
              </p>
            )}
            {status === 'error' && (
              <p style={{ color: 'red', textAlign: 'center', marginTop: '1rem' }}>
                {status === "error" && <p>{t[lang].error}</p>}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CareerHome;